import { useTracking } from '@xing-com/crate-communication-tracking';

import { ErrorType } from '../hooks/use-fabi-ai-generation';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const useTrackingSwimp = () => {
  const { track } = useTracking();

  const trackOpenModal = (): void => {
    track({
      type: 'nwt',
      event: 'clicked',
      eventSchema: 'extended',
      sentBy: 'welcome',
      element: 'apply_machine_open',
      moduleTitle: 'apply_machine',
      page: 'welcome/start/index',
      channel: 'wbm/Welcome',
    });
  };

  const trackCloseModal = (): void => {
    track({
      type: 'nwt',
      event: 'clicked',
      eventSchema: 'extended',
      sentBy: 'welcome',
      element: 'apply_machine_close',
      moduleTitle: 'apply_machine',
      page: 'welcome/start/index',
      channel: 'wbm/Welcome',
    });
  };

  const trackSubmit = (isFullInput: boolean): void => {
    track({
      type: 'nwt',
      event: 'opened',
      eventSchema: 'extended',
      sentBy: 'welcome',
      element: 'job_search_serp',
      elementDetail: isFullInput ? 'full_input' : 'partial_input',
      moduleTitle: 'apply_machine',
      page: 'welcome/start/index',
      channel: 'wbm/Welcome',
    });
  };

  const trackError = (error: ErrorType): void => {
    track({
      type: 'nwt',
      event: 'error_shown',
      eventSchema: 'extended',
      sentBy: 'welcome',
      moduleTitle: 'apply_machine',
      context:
        error === ErrorType.Prompt
          ? 'apply_machine_input_error'
          : 'apply_machine_service_error',
      page: 'welcome/start/index',
      channel: 'wbm/Welcome',
    });
  };

  const trackRetry = (error: ErrorType): void => {
    track({
      type: 'nwt',
      event: 'clicked',
      eventSchema: 'extended',
      sentBy: 'welcome',
      moduleTitle: 'apply_machine',
      element: 'retry',
      elementDetail:
        error === ErrorType.Prompt ? 'input_error' : 'service_error',
      page: 'welcome/start/index',
      channel: 'wbm/Welcome',
    });
  };

  return {
    trackOpenModal,
    trackCloseModal,
    trackSubmit,
    trackError,
    trackRetry,
  };
};
